import { render, staticRenderFns } from "./DetalleDisposicion.vue?vue&type=template&id=a54976aa&"
import script from "./DetalleDisposicion.vue?vue&type=script&lang=js&"
export * from "./DetalleDisposicion.vue?vue&type=script&lang=js&"
import style0 from "./DetalleDisposicion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports